import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { useAdminSave } from '../../AdminContext';
import { btnPrimary } from '../styles';
import { ease } from '../../../core/format/motion';

/**
 * Telefoon: opslaan net boven de tabbalk, alleen als er iets te bewaren is. Zegt erbij dat opslaan
 * live zet, want op de telefoon is er geen bovenbalk met die uitleg.
 */
export function AdminSaveBar() {
  const {
    dirty,
    saving,
    save,
    discard
  } = useAdminSave();
  const reduce = useReducedMotion();
  return <AnimatePresence data-id="element-5283" data-mp="2gtmemna2blfw">
      {dirty && <motion.div className="fixed inset-x-0 z-nav px-3 lg:hidden" style={{
      bottom: 'calc(4rem + env(safe-area-inset-bottom))'
    }} initial={reduce ? {
      opacity: 0
    } : {
      y: 16,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={reduce ? {
      opacity: 0
    } : {
      y: 16,
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease
    }} data-id="element-5284" data-mp="2guny9g559g98">
          <div role="region" aria-label="Niet-opgeslagen wijzigingen" className="mb-2 flex items-center gap-2 rounded-full border border-line bg-white p-1.5 pl-5 shadow-lg" data-id="element-5285" data-mp="1y1tuzjgvvcku">
            <span className="min-w-0 flex-1 leading-tight" data-id="element-5286" data-mp="1giv8em5gr11f">
              <span className="block truncate text-[14px] text-ink" data-id="element-5287" data-mp="1lalmn37iu8y4">Niet opgeslagen</span>
              <span className="block truncate text-[12px] text-muted" data-id="element-5288" data-mp="1lczgx9udnh4m">Opslaan zet het live</span>
            </span>
            <button type="button" onClick={discard} disabled={saving} className="min-h-[44px] rounded-full px-3 text-[14px] text-muted hover:text-ink" data-id="element-5289" data-mp="sly074b1ddiz">
              Verwerpen
            </button>
            <button type="button" onClick={() => void save()} disabled={saving} aria-busy={saving} className={btnPrimary} data-id="element-5290" data-mp="11mmcnuks75tr">
              {saving ? 'Opslaan…' : 'Opslaan'}
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}